// @ts-nocheck

import React from 'react';
import styled, { css } from 'styled-components';

import { Target } from '../../../../client';
import { KL_BADGE_HALO_DURATION } from '../../constants/ui';
import KLBadgeContainer from '../../containers/KLBadgeContainer';
import { type KLCollectibleId } from '../../types/collectible';

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
`;

const BADGE_MARGIN = 0.15; // em

const StyledBadgeContainer = styled(KLBadgeContainer)`
  ${({ $badgesByRow }) => {
    if ($badgesByRow) {
      const widthPercent = 100 / $badgesByRow;

      return css`
        width: calc(${widthPercent}% - ${2 * BADGE_MARGIN}em - ${Target.__MOBILE__ ? 0 : 1}em);
        margin: ${BADGE_MARGIN}em;
      `;
    }
  }}
`;

type KLBadgeListProps = {
  className?: string;
  badgeIds: Array<KLCollectibleId>;
  badgesByRow?: number;
};

const KLBadgeList = ({ className = '', badgeIds, badgesByRow = 4 }: KLBadgeListProps) => {
  return (
    <Wrapper className={className}>
      {badgeIds.map((badgeId, index) => (
        <StyledBadgeContainer
          key={`badge-${badgeId}`}
          badgeId={badgeId}
          $badgesByRow={badgesByRow}
          animationDelay={Math.floor(index * Math.random() * (KL_BADGE_HALO_DURATION / badgeIds.length))}
        />
      ))}
    </Wrapper>
  );
};

export default KLBadgeList;
